/**
 * Toasts. A module-level bus so any code (a mutation's onError, the 401 guard) can raise one
 * without a hook. <ToastViewport> (src/ui/Toast.jsx) is the one listener.
 *
 * How a toast reads: one short line, by what it is for.
 *   success  confirms what just happened, with the one fact that varies: "Refund of UGX 50,000 recorded",
 *            "Tickets resent by SMS". No record name or code the screen already shows.
 *   info     the answer to a check someone asked for: "Still pending"; "5 payments re-queried" + the counts.
 *   error    what failed, as the title; the server's message as the detail.
 * A detail line only for a fact the screen does not show. No toast when the screen already says it
 * (signing out lands on the sign-in page). No dashes as punctuation in the copy.
 *
 *   toast('Payout PO-2291 approved', { tone: 'success' })
 *   toast('Couldn’t export the orders', { tone: 'error', detail: e.message })
 *   toast('Session expired', { tone: 'error', action: { label: 'Sign in', onClick } })
 */
const listeners = new Set();
let seq = 0;

export const TOAST_BUS = { suppressErrors: false };

export function toast(title, { tone = 'info', detail, action, sticky = false } = {}) {
  if (tone === 'error' && TOAST_BUS.suppressErrors) return null;
  const item = { id: ++seq, title, tone, detail, action, sticky: sticky || !!action };
  listeners.forEach((fn) => fn({ type: 'add', item }));
  return item.id;
}

export const dismissToast = (id) => listeners.forEach((fn) => fn({ type: 'remove', id }));

export function subscribeToasts(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
